import React, { useState } from 'react';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function ChangePassword({ token, user, onDone, onLogout }) {
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [form, setForm] = useState({ newPassword: '', confirmPassword: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.newPassword.length < 6) {
      toast.error('A nova senha deve ter pelo menos 6 caracteres');
      return;
    }
    if (form.newPassword !== form.confirmPassword) {
      toast.error('As senhas não coincidem');
      return;
    }
    setLoading(true);
    try {
      await axios.post(
        `${API}/auth/change-password`,
        { new_password: form.newPassword },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Senha atualizada com sucesso!');
      onDone();
    } catch (error) {
      const message = error.response?.data?.detail || 'Erro ao atualizar a senha';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: '#0B1220' }}>
      <div
        className="w-full max-w-md rounded-2xl p-8"
        style={{ background: 'rgba(11,18,32,0.85)', backdropFilter: 'blur(24px)', border: '1px solid rgba(37,99,235,0.15)' }}
      >
        {/* Icon */}
        <div
          className="w-14 h-14 rounded-xl flex items-center justify-center mx-auto mb-5"
          style={{ background: 'linear-gradient(135deg, #2563EB, #00D4CB)' }}
        >
          <svg width="26" height="26" fill="none" stroke="#fff" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>

        <h2 className="text-2xl font-bold text-center mb-2" style={{ color: '#FFFFFF' }}>
          Crie sua nova senha
        </h2>
        <p className="text-sm text-center mb-6" style={{ color: 'rgba(229,231,235,0.5)' }}>
          Por segurança, você precisa definir uma nova senha antes de continuar.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-1.5">
            <label className="text-xs font-semibold tracking-wide uppercase" style={{ color: 'rgba(229,231,235,0.6)' }}>
              Nova senha
            </label>
            <input
              type={showPass ? 'text' : 'password'}
              data-testid="new-password-input"
              placeholder="••••••••"
              value={form.newPassword}
              onChange={e => setForm({ ...form, newPassword: e.target.value })}
              required
              className="w-full h-12 px-4 rounded-xl text-sm font-medium outline-none transition-all"
              style={{ background: 'rgba(20,35,61,0.6)', border: '1px solid rgba(37,99,235,0.2)', color: '#FFFFFF', caretColor: '#00D4CB' }}
              onFocus={e => { e.target.style.border = '1px solid rgba(0,212,203,0.5)'; }}
              onBlur={e => { e.target.style.border = '1px solid rgba(37,99,235,0.2)'; }}
            />
          </div>

          <div className="space-y-1.5">
            <label className="text-xs font-semibold tracking-wide uppercase" style={{ color: 'rgba(229,231,235,0.6)' }}>
              Confirmar nova senha
            </label>
            <input
              type={showPass ? 'text' : 'password'}
              data-testid="confirm-password-input"
              placeholder="••••••••"
              value={form.confirmPassword}
              onChange={e => setForm({ ...form, confirmPassword: e.target.value })}
              required
              className="w-full h-12 px-4 rounded-xl text-sm font-medium outline-none transition-all"
              style={{ background: 'rgba(20,35,61,0.6)', border: '1px solid rgba(37,99,235,0.2)', color: '#FFFFFF', caretColor: '#00D4CB' }}
              onFocus={e => { e.target.style.border = '1px solid rgba(0,212,203,0.5)'; }}
              onBlur={e => { e.target.style.border = '1px solid rgba(37,99,235,0.2)'; }}
            />
          </div>

          <label className="flex items-center gap-2 text-xs cursor-pointer select-none" style={{ color: 'rgba(229,231,235,0.5)' }}>
            <input type="checkbox" checked={showPass} onChange={() => setShowPass(!showPass)} />
            Mostrar senha
          </label>

          <button
            type="submit"
            disabled={loading}
            data-testid="change-password-submit"
            className="w-full h-12 rounded-xl font-semibold text-sm transition-all duration-200 mt-2"
            style={{
              background: loading ? 'rgba(37,99,235,0.5)' : 'linear-gradient(135deg, #2563EB 0%, #00D4CB 100%)',
              color: '#FFFFFF',
              boxShadow: loading ? 'none' : '0 4px 24px rgba(37,99,235,0.35)',
            }}
          >
            {loading ? 'Salvando…' : 'Salvar nova senha'}
          </button>
        </form>

        <button
          onClick={onLogout}
          className="w-full text-center text-xs mt-5 transition-colors"
          style={{ color: 'rgba(229,231,235,0.35)' }}
        >
          Sair
        </button>
      </div>
    </div>
  );
}
